import { deleteDocument } from "./deleteDocument";
import { getDocumentDownloadUrl } from "./getDocumentDownloadUrl";
import { getDocuments } from "./getDocuments";
import { getDownloadDocumentToken } from "./getDownloadDocumentToken";
import { uploadDocument } from "./uploadDocument";

export const documentsAPI = {
  deleteDocument,
  getDocuments,
  uploadDocument,
  getDocumentDownloadUrl,
  getDownloadDocumentToken,
};

export type DocumentsAPI = typeof documentsAPI;
